/** Até 8 dígitos. */
export function stripCepToDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 8);
}

/** Máscara progressiva: `99999-999`. */
export function formatCepMask(value: string): string {
  const d = stripCepToDigits(value);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5, 8)}`;
}

/** Para a API: só dígitos ou `null` se vazio. */
export function cepToApiPayload(maskedOrDigits: string): string | null {
  const d = stripCepToDigits(maskedOrDigits);
  return d.length === 0 ? null : d;
}
